(() => {
    const containerSelector = '#Avada-Joy_FloatingButton';
    const widgetSelector = 'joy-loyalty-widget';
    const fabSelector = 'joy-fab-button';
    const styleId = 'ka-joy-fab-theme';
    let preservedLabel = '';
    const styleText = `
        .fab {
            --fab-icon-size: 20px !important;
            position: relative !important;
            isolation: isolate !important;
            overflow: hidden !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            box-sizing: border-box !important;
            width: 160px !important;
            min-width: 160px !important;
            max-width: 160px !important;
            height: 52px !important;
            min-height: 52px !important;
            max-height: 52px !important;
            padding: 0 20px !important;
            gap: 10px !important;
            color: #0b223a !important;
            -webkit-text-fill-color: #0b223a !important;
            background: transparent !important;
            border: 0 !important;
            border-radius: 14px !important;
            box-shadow:
                0 14px 30px rgba(74, 55, 19, 0.12),
                0 4px 10px rgba(74, 55, 19, 0.08) !important;
            font-family: var(--base-font-family) !important;
            font-size: 14px !important;
            font-style: normal !important;
            font-weight: 600 !important;
            line-height: 1.2 !important;
            letter-spacing: normal !important;
            text-transform: none !important;
            transform: none !important;
            transition: none !important;
        }

        .fab::before {
            content: "";
            position: absolute;
            z-index: 0;
            top: 50%;
            left: 50%;
            width: 118px;
            height: 118px;
            border-radius: 50%;
            background: radial-gradient(
                circle at 32% 28%,
                #fff2b5 0%,
                #f8ce48 42%,
                #c69225 100%
            );
            box-shadow: 0 0 18px 7px rgba(248, 206, 72, 0.38);
            filter: blur(6px) saturate(1.12);
            will-change: transform;
            pointer-events: none;
            animation: ka-joy-blob-bounce 5s infinite ease;
        }

        .fab::after {
            content: "";
            position: absolute;
            z-index: 1;
            inset: 5px;
            background: rgba(255, 249, 232, 0.92);
            border-radius: 9px;
            outline: 2px solid rgba(255, 242, 181, 0.78);
            -webkit-backdrop-filter: blur(18px);
            backdrop-filter: blur(18px);
            pointer-events: none;
        }

        .fab > joy-icon {
            position: relative !important;
            z-index: 2 !important;
            width: 20px !important;
            min-width: 20px !important;
            height: 20px !important;
            color: #0b223a !important;
            flex: 0 0 20px !important;
        }

        .fab-label {
            position: relative !important;
            z-index: 2 !important;
            color: #0b223a !important;
            -webkit-text-fill-color: #0b223a !important;
            font-family: var(--base-font-family) !important;
            font-size: 14px !important;
            font-style: normal !important;
            font-weight: 600 !important;
            line-height: 14px !important;
            letter-spacing: normal !important;
            text-transform: none !important;
        }

        .fab:hover,
        .fab:active {
            color: #0b223a !important;
            -webkit-text-fill-color: #0b223a !important;
            background: transparent !important;
            border: 0 !important;
            box-shadow:
                0 14px 30px rgba(74, 55, 19, 0.12),
                0 4px 10px rgba(74, 55, 19, 0.08) !important;
            filter: none !important;
            transform: none !important;
        }

        .fab:focus-visible {
            outline: 3px solid #fff9e8 !important;
            outline-offset: 3px !important;
            box-shadow:
                0 0 0 2px #0b223a,
                0 14px 30px rgba(74, 55, 19, 0.12),
                0 4px 10px rgba(74, 55, 19, 0.08) !important;
        }

        @keyframes ka-joy-blob-bounce {
            0%,
            100% {
                transform: translate(-100%, -100%) translate3d(0, 0, 0);
            }

            25% {
                transform: translate(-100%, -100%) translate3d(100%, 0, 0);
            }

            50% {
                transform: translate(-100%, -100%) translate3d(100%, 100%, 0);
            }

            75% {
                transform: translate(-100%, -100%) translate3d(0, 100%, 0);
            }
        }

        @media screen and (max-width: 749px) {
            .fab {
                width: 152px !important;
                min-width: 152px !important;
                max-width: 152px !important;
                height: 48px !important;
                min-height: 48px !important;
                max-height: 48px !important;
                padding: 0 18px !important;
            }

            .fab::before {
                width: 110px;
                height: 110px;
            }
        }

        @media (prefers-reduced-motion: reduce) {
            .fab::before {
                animation: none;
                transform: translate(-50%, -50%) translate3d(52%, 8%, 0);
            }
        }
    `;
    const observedRoots = new WeakSet();
    const rootObservers = new WeakMap();

    const preserveLauncherLabel = (root) => {
        if (preservedLabel || !root.querySelector) {
            return;
        }

        const label = root.querySelector('.joy-fab-label');
        const labelText = label?.textContent?.trim();

        if (labelText) {
            preservedLabel = labelText;
        }
    };

    const injectFabStyle = (fabHost) => {
        const shadowRoot = fabHost.shadowRoot;

        if (!shadowRoot) {
            return;
        }

        if (!shadowRoot.getElementById(styleId)) {
            const style = document.createElement('style');
            style.id = styleId;
            style.textContent = styleText;
            shadowRoot.append(style);
        }

        const label = shadowRoot.querySelector('.fab-label');
        const labelText = label?.textContent?.trim();

        if (!preservedLabel && labelText) {
            preservedLabel = labelText;
        } else if (label && preservedLabel && labelText !== preservedLabel) {
            label.textContent = preservedLabel;
        }
    };

    const scanRoot = (root) => {
        preserveLauncherLabel(root);

        if (root instanceof ShadowRoot && root.host.matches(fabSelector)) {
            injectFabStyle(root.host);
        }

        root.querySelectorAll(fabSelector).forEach((fabHost) => {
            injectFabStyle(fabHost);
            observeRoot(fabHost.shadowRoot);
        });

        root.querySelectorAll(widgetSelector).forEach((widgetHost) => {
            observeRoot(widgetHost.shadowRoot);
        });
    };

    const observeRoot = (root) => {
        if (!root || observedRoots.has(root)) {
            return;
        }

        observedRoots.add(root);

        const observer = new MutationObserver(() => scanRoot(root));
        observer.observe(root, { childList: true, subtree: true });
        rootObservers.set(root, observer);
        scanRoot(root);
    };

    const attachToContainer = (container) => {
        observeRoot(container);

        Promise.all([
            customElements.whenDefined(widgetSelector),
            customElements.whenDefined(fabSelector),
        ]).then(() => scanRoot(container));
    };

    const container = document.querySelector(containerSelector);

    if (container) {
        attachToContainer(container);
        return;
    }

    const documentObserver = new MutationObserver(() => {
        const nextContainer = document.querySelector(containerSelector);

        if (!nextContainer) {
            return;
        }

        documentObserver.disconnect();
        attachToContainer(nextContainer);
    });

    documentObserver.observe(document.documentElement, {
        childList: true,
        subtree: true,
    });
})();
